import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "config/config";
import getTimezone from "utils/getTimezone";

export const lobbyApi = createApi({
  reducerPath: "lobbyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${config.lobbyApiBaseUrl}/v1/`,
    credentials: "include",
    headers: {
      Timezone: getTimezone(),
    },
  }),
  endpoints: (builder) => ({
    getMyself: builder.query({
      query: () => "users/company_user/myself/",
    }),
  }),
});

export const {
  useGetMyselfQuery,
} = lobbyApi;
